import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import './index.css';

function HomeMenu({ show, onClose }) {
  return (
    <div className={`overlay ${show ? 'show' : ''}`}>
      <div className='overlay-header'>
        <div className="overlay-header-menu text-2xl">
          <span>MENU</span>
          <button className="text-4xl" onClick={onClose}>
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>
      </div>

      <div className='overlay-content'>
        <div className='overlay-content-box'>
          <Link to='/constituicoes' className='box-text'><h3>CONSTITUIÇÕES</h3></Link>
          <Link to='/constituicoes/1824' className='box-text'>1824</Link>
            <div className="mb-4 flex gap-0 p-0 m-0">
              <Link to='/constituicoes/1824/1' className='p-1 text-[18px] text-inherit no-underline hover:text-black transition-colors duration-300'>I</Link>
              <Link to='/constituicoes/1824/2' className='p-1 text-[18px] text-inherit no-underline hover:text-black transition-colors duration-300'>II</Link>
              <Link to='/constituicoes/1824/3' className='p-1 text-[18px] text-inherit no-underline hover:text-black transition-colors duration-300'>III</Link>
              <Link to='/constituicoes/1824/4' className='p-1 text-[18px] text-inherit no-underline hover:text-black transition-colors duration-300'>IV</Link>
              <Link to='/constituicoes/1824/5' className='p-1 text-[18px] text-inherit no-underline hover:text-black transition-colors duration-300'>V</Link>
            </div>

          <Link to='/constituicoes/1891' className='box-text'>1891</Link>
          <Link to='/constituicoes/1934' className='box-text'>1934</Link>
          <Link to='/constituicoes/1937' className='box-text'>1937</Link>
          <Link to='/constituicoes/1946' className='box-text'>1946</Link>
          <Link to='/constituicoes/1967' className='box-text'>1967</Link>
          <Link to='/constituicoes/1988' className='box-text'>1988</Link>
        </div>

        <div className='overlay-content-box'>
          <h3>O PALÁCIO DO CONGRESSO NACIONAL</h3>
          <Link to='/sedeSenado' className='box-text'>Senado Federal</Link>
          <Link to='/parlamentoNovaCapital' className='box-text'>O Parlamento e a nova Capital</Link>
          <Link to='/ConstrucaoInstalacao' className='box-text'>Construção e Instalação</Link>
          <Link to='/Inauguracao' className='box-text'>Inauguração do Congresso Nacional</Link>
        </div>

        <div className='overlay-content-box'>
          <h3>POSSES PRESIDENCIAIS</h3>
          <Link to='/ditadura' className='box-text'>Da Democracia à Ditadura 1946 - 1964</Link>
          <Link to='/militar' className='box-text'>Ditadura Militar 1964 - 1984</Link>
        </div>

        <div className='overlay-content-box'>
          <h3>EIXOS TEMÁTICOS</h3>
          <Link to='/legislativo' className='box-text'>Poder Legislativo</Link>
          <Link to='/rel' className='box-text'>Relações internacionais</Link>
          <Link to='/terra-e-poder' className='box-text'>Terra e poder</Link>
          <Link to='/ambiental' className='box-text'>Meio ambiente</Link>
            <div className="mb-4 flex">
              <Link to='/ambiental' className='box-text w-6 p-0' >I</Link>
              <Link to='/ambiental/2' className='box-text p-0'>II</Link>
            </div>  
          <Link to='/religiao' className='box-text'>Religião</Link>
          <div className="mb-4 flex">
              <Link to='/religiao' className='box-text w-6 p-0' >I</Link>
              <Link to='/religiao2' className='box-text p-0'>II</Link>
            </div>  
          <Link to='/direitos' className='box-text'>Direitos Humanos</Link>
          <Link to='/cultura' className='box-text'>Cultura e Patrimônio</Link>
            <div className="mb-4 flex">
                <Link to='/cultura' className='box-text w-6 p-0' >I</Link>
                <Link to='/cultura2' className='box-text p-0'>II</Link>
            </div> 
          <Link to='/origemevolucaoforma' className='box-text'>O Parlamento: Origem, Evolução e Forma</Link>
              <div className="mb-4 flex">
                <Link to='/parlamento' className='box-text p-0' >O Parlamento Brasileiro e as Forças Militares</Link>
              </div> 
          {/* <Link to='/racial' className='box-text'>Questão Racial</Link> */}
        </div>

        <div className='overlay-content-box'>
          <Link to='/documentarios' className='box-text'><h3>DOCUMENTÁRIOS</h3></Link>
          <Link to='/episodios/1' className='box-text'>Bernardo Cabral</Link>
          <Link to='/episodios/2' className='box-text'>Jarbas Passarinho</Link>
          <Link to='/episodios/3' className='box-text'>Marco Maciel</Link>
          <Link to='/episodios/4' className='box-text'>José Genoíno</Link>
          <Link to='/episodios/5' className='box-text'>O Golpe de 1964 e o Parlamento</Link>
          <Link to='/episodios/6' className='box-text'>A Redemocratização</Link>
          <Link to='/episodios/7' className='box-text'>A Constituição de 1888</Link>
          <Link to='/episodios/8' className='box-text'>A Constituição de 1824 e os escravizados</Link>
          <Link to='/episodios/9' className='box-text'>Yanomami</Link>
        </div>
      </div>
    </div>
  );
}

export default HomeMenu;
